import MainServices from "./Main.services";

class ModelsServices {
    constructor() {
        this.entitiesPath = "oneintel/models/entities"
        this.negativePositivePath = "oneintel/models/negativepositive"
    }

    async setNewEntitiesModel(text, resp) {
        const guid = await MainServices.getGUID();
        const filename = `${this.entitiesPath}/${guid}.json`
        return MainServices.uploadFile(filename, JSON.stringify({
            input: text,
            output: resp
        }));
    }

    async setNewPositiveNegativeModel(text, resp) {
        const guid = await MainServices.getGUID();
        const filename = `${this.negativePositivePath}/${guid}.json`
        return MainServices.uploadFile(filename, JSON.stringify({
            input: text,
            output: resp
        }));
    }
}

export default new ModelsServices();
